'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IntegrationRouteRest = function () {
  function IntegrationRouteRest($http) {
    (0, _classCallCheck3.default)(this, IntegrationRouteRest);

    this.$http = $http;
    this.sprintf = require("sprintf-js").sprintf;

    this.PATH = {
      LIST: 'integration-routes/',
      DETAIL: 'integration-routes/%1$s/'
    };
  }

  (0, _createClass3.default)(IntegrationRouteRest, [{
    key: 'create',
    value: function create(postData) {
      return this.$http.post(this.PATH.LIST, postData);
    }
  }, {
    key: 'update',
    value: function update(id, postData) {
      return this.$http.put(this.sprintf(this.PATH.DETAIL, id), postData);
    }
  }, {
    key: 'save',
    value: function save(postData) {
      return postData.id ? this.update(postData.id, postData) : this.create(postData);
    }
  }, {
    key: 'getList',
    value: function getList(params) {
      return this.$http.get(this.PATH.LIST, { params: params });
    }
  }, {
    key: 'read',
    value: function read(id) {
      return this.$http.get(this.sprintf(this.PATH.DETAIL, id));
    }
  }]);
  return IntegrationRouteRest;
}();

exports.default = IntegrationRouteRest;


//////////////////
// WEBPACK FOOTER
// ./src/api/IntegrationRouteResource.js
// module id = 316
// module chunks = 0